import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e6d80d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rel" }
const _hoisted_2 = { class: "abs flex-col icons" }
const _hoisted_3 = ["onClick"]

import { ref, watch, reactive } from 'vue'
import TableLike from '@/components/common/TableLike.vue'
import { getPlan } from '../model/ingredients'

export default /*#__PURE__*/_defineComponent({
  props: ['list', 'data'],
  emits: ['update:list'],
  setup(__props, { emit }) {

const props = __props


// 只有在list为空时添加
const arr = [...props.list]
if (!arr.length) {
  // 颜色
  props.data.colorCard &&
    props.data.colorCard.forEach((v) => {
      arr.push({ color: v.code })
    })
  // 尺码
  const { ingredientsId, ingredientsSizeId } = reactive(props.data)
  if (ingredientsId) {
    getPlan(ingredientsId).then((data: any) => {
      data[2].tabs.forEach((v) => {
        if (v.value === ingredientsSizeId) {
          list.value[0].size = v.labelJP
        }
      })
    })
  }
}
arr.push({})
const list = ref(arr)

const columns = [
  { label: '尺码', prop: 'size', slotName: 'size' },
  { label: '颜色', prop: 'color', slotName: 'color' },
  { label: '数量', prop: 'quantity', slotName: 'quantity' }
].fort()

const add = () => {
  list.value.push({})
}

const del = (i: number) =>
  list.value.length > 1 && list.value.length < 20 && list.value.splice(i, 1)

watch(
  list,
  (val) => {
    emit(
      'update:list',
      val.filter(
        (v: any) =>
          Object.values(v).length === 3 && Object.values(v).every((v) => v)
      )
    )
  },
  { deep: true }
)

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_input_number = _resolveComponent("el-input-number")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("i", {
          class: "fa fa-plus-circle",
          style: {"color":"#1890ff"},
          onClick: add
        })
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (v, i) => {
        return (_openBlock(), _createElementBlock("div", { key: i }, [
          _createElementVNode("i", {
            class: "fa fa-minus-circle",
            style: {"color":"var(--rcolor)"},
            onClick: ($event: any) => (del(i))
          }, null, 8, _hoisted_3)
        ]))
      }), 128))
    ]),
    _createVNode(TableLike, {
      columns: _unref(columns),
      data: list.value
    }, {
      size: _withCtx(({ item }) => [
        _createVNode(_component_el_input, {
          class: "fl-l",
          modelValue: item.size,
          "onUpdate:modelValue": ($event: any) => ((item.size) = $event),
          modelModifiers: { trim: true }
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      color: _withCtx(({ item }) => [
        _createVNode(_component_el_input, {
          modelValue: item.color,
          "onUpdate:modelValue": ($event: any) => ((item.color) = $event),
          modelModifiers: { trim: true }
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      quantity: _withCtx(({ item }) => [
        _createVNode(_component_el_input_number, {
          class: "fl-r",
          modelValue: item.quantity,
          "onUpdate:modelValue": ($event: any) => ((item.quantity) = $event),
          controls: false,
          min: 1,
          max: 99999,
          "step-strictly": ""
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _: 1
    }, 8, ["columns", "data"])
  ]))
}
}

})